import { connect } from 'react-redux'

import { doOpenNotePage, doOpenTicketPage } from 'actions/pages'
import ListenToKeyboard from 'components/ListenToKeyboard'

// eslint-disable-next-line no-unused-vars
const select = state => ({
  disableForInput: true,
  preventDefault: true,
})

const perform = (dispatch, ownProps) => ({
  onR: () => {
    dispatch(
      doOpenTicketPage(ownProps.ticketId, { viaKeyboard: true, replying: true })
    )
  },
  onN: () => dispatch(doOpenNotePage(ownProps.ticketId)),
  onF: () =>
    dispatch(
      doOpenTicketPage(ownProps.ticketId, {
        replying: true,
        forwarding: true,
      })
    ),
})
export default connect(select, perform)(ListenToKeyboard)
